import { TabBar } from './TabBar';
import { TabContent } from './TabContent';
import { useTabs } from '@/hooks/useTabs';

export function TabPanel() {
  const { tabs, activeTabId, activateTab, closeTab } = useTabs();

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <TabBar
        tabs={tabs}
        activeTabId={activeTabId}
        onActivate={activateTab}
        onClose={closeTab}
      />
      <div className="flex-1 overflow-hidden">
        {tabs.map((tab) => (
          <TabContent
            key={tab.id}
            tab={tab}
            isActive={tab.id === activeTabId}
          />
        ))}
      </div>
    </div>
  );
}
